<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <!-- 删除提示框 -->
    <div class="msgBox removeBox" v-if="removeType">
      <div class="contv">
        <p class="title">提示</p>
        <p class="txt">确认删除该机构号管理员账号吗？</p>
        <div class="btnBox">
          <button class="btn btn-remove" @click="removeSub">删除</button>
          <button class="btn btn-close" @click="removeType=false">取消</button>
        </div>
      </div>
    </div>

    <!-- 添加管理员 -->
    <div class="msgBox tipsBox addBox " v-if="addType">
      <div class="contv">
        <p class="title">添加管理员</p>
        <form>
          <div class="write-txt">
            <p>用户名：</p>
            <input type="text" v-model="addObj.name">
          </div>
          <div class="write-txt">
            <p>手机号：</p>
            <input type="text" v-model="addObj.mobile" @input="numCheck(addObj.mobile,11,'mobile')">
          </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-sub" @click="addSub">添加</button>
          <button class="btn btn-close" @click="addHide">取消</button>
        </div>
      </div>
    </div>

    <!-- 列表 -->
    <div class="content" >
      <myHeader></myHeader>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>机构</p>
          <div class="btnBox">
            <button class="btn btn-add" @click="addShow()">添加管理员</button>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="(index+1)">{{(index+1)}}</p>
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.mobile">{{item.mobile}}</p>
              <p style="color:#FF5156;" @click="removeShow(item)">删除</p>
            </div>
          </div>
          <!-- <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage1"
              :page-size="100"
              layout="prev, pager, next, jumper"
              :total="1000">
            </el-pagination> 
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import { getOrgManageList,delOrgManage,addOrgManage } from "@/assets/js/api";
export default {
  name: "topic-config",
  data() {
    return {
      navId:'5',
      childrenID:'5-4',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'管理员姓名'},
        {id:3,title:'手机号'},
      ],
      dataList:[],
      currentPage1: 2,
      addType:false,
      removeType:false,
      reviseType:false,
      openType:false,
      replaceType:false,
      obj:{
        id:''
      },
      token:'',
      addObj:{
        id:'',
        name:'',
        mobile:'',
      },
      removeID:'',
      totalPage:0
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.token = this.$refs.navBox.userData.token;
    this.obj.id = this.$route.query.organID;
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    getList(){
      var that = this;
      getOrgManageList(this.obj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.dataList = data.data;
          that.totalPage = data.data.total_page;
        } else {
          that.$message(data.msg);
        }
      })
    },

    removeShow(e){
      this.removeType = true;
      this.removeID = e.id;
    },

    removeSub(){
      var that = this;
      delOrgManage({id:this.removeID},this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('删除成功');
          that.removeType = false;
          that.getList();
        } else {
          that.$message(data.msg);
        }
      })
    },

    addShow(){
      this.addType = true;
      this.addObj.id = this.obj.id;
    },

    addHide(){
      this.addObj.name = '';
      this.addObj.mobile = '';
      this.addType = false;
    },

    addSub(){
      var that = this;
      var regex = /^(13[0-9]|14[0-9]|15[0-9]|17[0-9]|18[0-9])\d{8}$/i;
      if(this.addObj.name == ''){
        that.$message('请输入正确的姓名！');
        return false;
      } else if(this.addObj.mobile === '' || !regex.test(this.addObj.mobile)){
        that.$message('请输入正确的手机号码！');
        return false;
      };
      addOrgManage(this.addObj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('添加成功!');
          that.getList();
          that.addHide();
        }
      })
    },

    numCheck(e,i,type){
      var that = this;
      var num = e;
      num = num.length;
      if(num > i){
          if(type == 'mobile'){
              e = e.slice(0,11);
              that.addObj.mobile = e;
          } else {
              that.code = JSON.stringify(e).slice(0,4)
          }
      }
    },
  },
};
</script>
<style scoped>
.dataList .listItem p,
.organiza-list p{
  width: 25%; 
}

.organiza-txt{
  height: calc(100% - 120px);
}

.organiza-cont .detail-title{
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
  color: #3D3D3D;
}

.organiza-cont .info-item {
  margin-bottom: 30px;
}

.organiza-cont .info-item p{
  font-size: 20px;
  color: #3D3D3D;
  display: inline-block;
  vertical-align: top;
  line-height: 36px;
  height: 36px;
}

.organiza-cont .info-item p.info-msg{
  font-size: 14px;
  margin-left: 24px;
}

.organiza-cont .info-item p.info-title{
  width: 100px;
}

.organiza-cont .info-item input{
  font-size: 20px;
  color: #3D3D3D;
  display: inline-block;
  vertical-align: top;
  width: 300px;
  line-height: 36px;
  height: 36px;
  border: solid 1px #BFC3CD;
  border-radius: 6px;
  padding: 5px 10px;
}

.organiza-cont .info-item button{
  color: #457AFF;
  font-size: 20px;
  display: inline-block;
  vertical-align: top;
  line-height: 36px;
  height: 36px;
  margin-left: 18px;
}

.organiza-cont .btn-sub{
  width: 200px;
  height: 60px;
  left: 60px;
  border-radius: 30px;
  color: #fff;
  text-align: center;
  font-size: 22px;
  background-color: #457AFF;
  margin-top: 30px;
}

</style>



// WEBPACK FOOTER //
// src/admin/organ.vue